import { Component, ElementRef, Host, Input, OnInit, Optional, SkipSelf, ViewChild } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormGroupBase } from 'src/app/shared/inputs/form-group-base';
import { InputTextDateComponent } from 'src/app/shared/inputs/input-text-date/input-text-date.component';
import { DateValidator } from 'src/app/validators/date-validator';
import { LoginValidator } from 'src/app/validators/login-validator';

@Component({
  selector: 'app-input-citizen-id-with-date',
  templateUrl: './input-citizen-id-with-date.component.html',
  styleUrls: ['./input-citizen-id-with-date.component.scss']
})
export class InputCitizenIdWithDateComponent extends FormGroupBase<any> implements OnInit {

  @Input() groupClass?;

  @ViewChild('inpCitizen') inpCitizen: ElementRef;
  @ViewChild(InputTextDateComponent) inputTextDateComp: InputTextDateComponent;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private fb: FormBuilder
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
  }

  createFormGroupForCitizenId(): FormGroup {
  return this.fb.group({
    citizenId: [
      null,
      [
        LoginValidator.validCitizenId,
        Validators.minLength(13),
      ],
    ],
    date: [
      null,
      [
        DateValidator.validateLeapYear(this.translate.currentLang),
      ],
    ],
  });
}

  focusDay(event) {
    // if (this.control.get('citizenId').value.length === this.inpCitizen.nativeElement.maxLength) {
    //   this.inputTextDateComp.focusDay();
    // }
  }


}
